// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"O1-z","sponsoredTooltipWrapper":"P1-z","sponsoredTooltip":"Q1-z","newCard":"R1-z"};